import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const variants = {
  primary: "bg-red-900 text-white hover:bg-red-800",
  secondary: "bg-gray-200 text-gray-800 hover:bg-gray-300",
  outline:
    "bg-white border-2 border-slate-200 text-slate-700 hover:border-red-600 hover:bg-red-50",
};

export const ActionButton = ({
  to,
  variant = "primary",
  className = "",
  children,
  ...props
}) => {
  const classes = [
    "rounded-xl h-10 px-6 text-sm font-semibold inline-flex items-center justify-center transition-all duration-200 gap-2",
    variants[variant],
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
};

ActionButton.propTypes = {
  to: PropTypes.string,
  variant: PropTypes.oneOf(Object.keys(variants)),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};
